import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";

@observer
export class AssinaturaAguardandoPage extends React.Component<{}, {}> {

  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
    AppStore.setTitle(" ");
  }

  render() {

    return (
      <div style={{textAlign: 'center'}}>
      <video autoPlay loop src="/images/carregando_pagamento.mp4" width={1000}></video>
      </div>
    );
  }
}

export default AssinaturaAguardandoPage;
